// Func = limiting Scope for this file
var lastScrollTop = 0;


(function(){
	if (document.querySelector('.content-booking .date.checkin input')) {		
		document.addEventListener('click',function (e) {
			var element = document.querySelector('.content-booking .ui-datepicker-inline.ui-datepicker')
			if (e.target != document.querySelector('.content-booking .date.checkin input')) {
				element.classList.remove("active");
			}
		})
	}
	if (document.querySelector('.content-booking .date.checkin input')) {
		document.querySelector('.content-booking .date.checkin input').setAttribute('onClick','calendarClick()')
	}
	

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			//
		});

		// RELLAX
		if ( document.querySelector('.rellax') ) {
			const rellax = new Rellax('.rellax', {
				center:true
			});
		}

		// TOGGLE HEADER BOOKING
		document.querySelectorAll('.js-bookingToggle').forEach(btn => {
			btn.addEventListener('click', e => {
				const currentTarget = document.querySelector( btn.getAttribute('href') );
				e.preventDefault();

				// CLOSE MAIN NAV
				document.querySelectorAll('.header').forEach( h => h.classList.remove('navActive') );
				document.querySelectorAll('.js-navToggle, .mainNav').forEach( m => m.classList.remove('active') );

				currentTarget.classList.toggle('active');
				btn.classList.toggle('active', currentTarget.classList.contains('active'));
				document.querySelector('.header').classList.toggle('bookingActive', currentTarget.classList.contains('active'));
			});
		});

		// TOGGLE HEADER NAV
		document.querySelectorAll('.js-navToggle').forEach(btn => {
			btn.addEventListener('click', e => {
				const currentTarget = document.querySelector( btn.getAttribute('href') );
				e.preventDefault();

				// CLOSE MAIN BOOKING
				document.querySelectorAll('.header').forEach( h => h.classList.remove('bookingActive') );
				document.querySelectorAll('.js-bookingToggle, .mainBooking').forEach( m => m.classList.remove('active') );

				currentTarget.classList.toggle('active');
				btn.classList.toggle('active', currentTarget.classList.contains('active'));
				document.querySelector('.header').classList.toggle('navActive', currentTarget.classList.contains('active'));
			});
		});

		// POPULATE HEADER 3RD NAV
		document.querySelectorAll('.js-thirdNav').forEach(nav => {
			document.querySelectorAll('.tertiary-navigation__item').forEach( item => nav.innerHTML += `<li>${item.innerHTML}</li>` );
		});

		// Main Nav Dropdown
		// $("#primary-nav li").hover(function(){
		// 	$(this).addClass("hover");
		// 	$('ul.submenu',this).fadeIn(200);
		// }, function(){
		// 	$(this).removeClass("hover");
		// 	$('ul.submenu',this).fadeOut(200);
		// });

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
		const DATE_FORMAT_ALT = "mm/dd/yy";
		const DATE_OPS = {
			changeMonth: false,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 2,
			minDate: 0,
			beforeShowDay: calendarRange,
			onSelect: calendarSelect
		};

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		let op = 0;
		function calendarRange(date){
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if ( d1 && date.getTime() == d1.getTime() ) {
				DATE_STYLE[1] = 'highlight-edge highlight-edge-start';
			}else if( d2 && date.getTime() == d2.getTime() ){
				DATE_STYLE[1] = 'highlight-edge highlight-edge-end';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}
		function calendarSelect (date) {
			let start = ($('#CheckIn').val() !== '') ? $('#CheckIn').val() : $.datepicker.formatDate(DATE_FORMAT, new Date()),
				end = ($('#CheckOut').val() !== '') ? $('#CheckOut').val() : $.datepicker.formatDate(DATE_FORMAT, new Date());
			let startDate = $.datepicker.parseDate(DATE_FORMAT, start);
			let selectedDate = $.datepicker.parseDate(DATE_FORMAT, date);

			if ( op === 0 ) {
				op = 1;
				start = date;
				end =  date;
				$("#pickup").val($.datepicker.formatDate(DATE_FORMAT_ALT, selectedDate) + ' - ');
				$(".content-booking #pickup").val($.datepicker.formatDate(DATE_FORMAT_ALT, selectedDate) + ' - ');
				
				
			} else {
				op = 0;
				if(selectedDate <= startDate){
					end = start;
					start = date;
				} else {
					end =  date;
				}

				$("#pickup").val($.datepicker.formatDate(DATE_FORMAT_ALT, startDate) + ' - ' + $.datepicker.formatDate(DATE_FORMAT_ALT, selectedDate));
				$(".content-booking #pickup").val($.datepicker.formatDate(DATE_FORMAT_ALT, startDate) + ' - ' + $.datepicker.formatDate(DATE_FORMAT_ALT, selectedDate));
			}

			let diffTime = Math.abs(selectedDate - startDate);
			let diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 

			console.log( diffDays );

			let nights = [...document.querySelectorAll( "#nights" )]
			nights.forEach( ( item, index ) => { item.value = diffDays } )

			$('#CheckIn').val( start );
			$('#CheckOut').val( end );
			$('.content-booking #CheckIn').val( start );
			$('.content-booking #CheckOut').val( end );
		}

        $( "#dateCalendar" ).datepicker( DATE_OPS );
        $( ".content-booking" ).datepicker( DATE_OPS );

		$("#pickup").on('keyup', function(){
			const dates = $(this).val().split(' - ').map( d => $.datepicker.formatDate(DATE_FORMAT, $.datepicker.parseDate(DATE_FORMAT_ALT, d)) );
			$('#CheckIn').val( dates[0] );
			$('#CheckOut').val( dates[1] );
		});


		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		document.getElementById('header').classList.add('scroll');
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		document.getElementById('header').classList.remove('scroll');
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function calendarClick() {
	var element = document.querySelector('.content-booking .ui-datepicker-inline.ui-datepicker');
	element.classList.toggle("active");
  }
